import { render, staticRenderFns } from "./TrazabilidadSolicitud.vue?vue&type=template&id=ed38c6c2&"
import script from "./TrazabilidadSolicitud.vue?vue&type=script&lang=js&"
export * from "./TrazabilidadSolicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports